export default __webpack_public_path__ + "images/Y1.27b6cba.png";